import {
  Grid,
  FormControl,
  Box,
  Typography,
  TextareaAutosize,
  Tooltip,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import EditIcon from "@mui/icons-material/Edit";
import CommonDatePicker from "../../../Base/views/CommonDatePicker";
import MaterialTable from "material-table";
import "jspdf-autotable";
import CommentIcon from "@mui/icons-material/Comment";
import { DateConvertInDbFormat } from "../../../Base/helper/baseFunctions";
import BackdropMeepl from "../../../Ancillary/AnimationComponents/BackdropMeepl";
import { GetEmployeeTargetManagementAction, UpdateEmployeeTargetManagementAction } from "../../../../../store/ATS/User/Action";

const ATSUsersTargetGrid = ({featuresData}) => {
  const dispatch = useDispatch();
  const date = new Date();
  const { targetConfigLoading, targetEmployeeData } = useSelector(state => state.AtsReducer?.AtsUserReducer);
  const { minDojYear } = useSelector(
    (state) => state?.AncillaryReducer?.WorkSpaceDojReducer
  );
  const [filters, setFilters] = useState({
    month_year: `${date.getFullYear()}-${
      date.getMonth() + 1
    }-${date.getDate()}`,
    ats_work_location_id: []
  });
 
  useEffect(() => {
    const [f_year, month] = filters.month_year.split("-");
    const f_month = parseInt(month, 10).toString();
    dispatch(
      GetEmployeeTargetManagementAction({
        month: f_month,
        year: f_year,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [filters]);

  const handleSubmitRowData = (rowData, actionType) => {
    const [f_year, month] = filters.month_year.split("-");
    const f_month = parseInt(month, 10).toString();
    
    if (actionType === "edit" && rowData?.employee_id) {
        dispatch(
          UpdateEmployeeTargetManagementAction({
            ...rowData,
            employee_fk: rowData?.employee_id,
            month: f_month,
            year: f_year,
            record_date: rowData?.record_date ? rowData?.record_date : DateConvertInDbFormat(),
          })
        );
    } else {
      console.log("Invalid action type:", actionType);
    }
  };

  const handleFilter = (event, value) => {
    if (["month_year"].includes(event?.target?.name)) {
      setFilters({ ...filters, [event?.target?.name]: event?.target?.value });
    }
  };
  const titleContent = (
    <Box>
      <Typography variant="h6" fontWeight={600}>
        Recruiter
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Recruiter monthly target
      </Typography>
    </Box>
  );

   
  return (
    
      <Box
        sx={{
          maxHeight: "calc(100vh - 85px)",
          overflowY: "auto",
        }}
      >
        <Grid
          py={1}
          container
          alignItems="center"
        >
          <Grid item>
            <FormControl>
              <CommonDatePicker
                name="month_year"
                openTo="month"
                views={["year", "month"]}
                label="Month and Year"
                pickerType="date"
                size="small"
                onKeyDown={(e) => e.preventDefault()}
                onKeyPress={(e) => e.preventDefault()}
                pickerFormat="MM/yyyy"
                DefaultDTvalue={filters.month_year}
                maxDate={
                  new Date(
                    new Date().getFullYear(),
                    new Date().getMonth() + 2,
                    1
                  )
                }
                minDate={
                  new Date(
                    new Date(minDojYear).setFullYear(
                      new Date(minDojYear).getFullYear() - 1
                    )
                  )
                }
                handleChange={(value) =>
                  handleFilter({
                    target: {
                      name: "month_year",
                      value: value
                        ? `${value?.getFullYear()}-${(
                            "0" +
                            (value?.getMonth() + 1)
                          ).slice(-2)}-${("0" + value?.getDate()).slice(-2)}`
                        : "",
                    },
                  })
                }
              />
            </FormControl>
          </Grid>
         
        </Grid>
        <Box sx={{position: "relative"}}>
          <MaterialTable
            isLoading={targetConfigLoading}
            columns={[
              {
                title: "Recruiter",
                headerStyle: {
                  textAlign: "start",
                  paddingLeft: "2%",
                },
                cellStyle: {
                  textAlign: "start",
                  padding: "0px 0px 0px 2%",
                },
                field: "employee_name",
                editable: "never",
              },
              {
                title: "Email",
                field: "email_id",
                editable: "never", 
                filtering: false,
                headerStyle: {
                  textAlign: "start",
                  paddingLeft: "2%",
                },
                cellStyle: {
                  textAlign: "start",
                  padding: "0px 0px 0px 2%",
                },
              },
              {
                title: "Target",
                field: "target",
                headerStyle: {
                  textAlign: "start",
                  paddingLeft: "2%",
                },
                cellStyle: {
                  textAlign: "start",
                  padding: "0px 0px 0px 2%",
                },
                validate: (rowData) => {
                  if (rowData?.target) {
                    return "";
                  } else {
                    return "Amount cannot be empty";
                  }
                },
                editComponent: (props) => {
                    return (
                    <Box width={"100%"}>
                        <TextField
                            required={true}
                            type="number"
                            variant="standard"
                            placeholder="Enter Target"
                            value={props?.value}
                            inputProps={{ min: 0 }}
                            onChange={(e) => {
                              if(Number(e.target.value) < 0) return
                                props.onChange(e.target.value)
                              }
                            }
                        />
                    </Box>
                    );
                },
                render: (rowData) => rowData?.target || "0"
              },
              {
                title: "Comment",
                headerStyle: {
                  textAlign: "center",
                  paddingLeft: "2%",
                },
                cellStyle: {
                  textAlign: "center",
                  padding: "5px 0px 0px 2%",
                },
                field: "comments",
                grouping: false,
                sorting: false,
                render: (rowData) => {
                  return (
                    <Box width={"100%"}>
                      <Tooltip title={rowData.comments || ""} arrow>
                        <CommentIcon
                          sx={{
                            fontSize: "20px",
                            color: rowData.comments ? "#637381" : "#95a0ab",
                            cursor: rowData.comments ? "pointer" : "default",
                          }}
                        />
                      </Tooltip>
                    </Box>
                  );
                },
                editComponent: (props) => {
                  return (
                    <Box width={"100%"}>
                      <TextareaAutosize
                        minRows={1}
                        maxRows={1}
                        placeholder={"Comment"}
                        value={props.value || ""}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value.length <= 50) {
                            props.onChange(value);
                          }
                        }}
                        style={{
                          width: "100%",
                          borderRadius: "5px",
                          padding: "8px",
                          fontSize: "14px",
                          fontFamily: "inherit",
                          border: "1px solid #ccc",
                          resize: "none",
                        }}
                      />

                      <Typography
                        variant="caption"
                        sx={{
                          display: "block",
                          textAlign: "right",
                          color: "#888",
                        }}
                      >
                        {props.rowData?.comments?.length || 0}/50
                      </Typography>
                    </Box>
                  );
                },
              },
            ]}
            data={targetEmployeeData || []}
            options={{
              maxBodyHeight: "calc(100vh - 300px)",
              minBodyHeight: "calc(100vh - 300px)",
              rowStyle: { fontSize: "13px", height: "30px" },
              headerStyle: {
                padding: "7px 0px 7px 0px",
                fontWeight: "bold",
              },
              sorting: true,
              search: true,
              searchText: "",
              searchFieldAlignment: "right",
              searchAutoFocus: false,
              searchFieldVariant: "standard",
              filtering: false,
              paging: true,
              pageSizeOptions: [25, 50],
              pageSize: 25,
              paginationType: "stepped",
              showFirstLastPageButtons: false,
              paginationPosition: "bottom",
              exportButton: false,
              exportAllData: false,
              addRowPosition: "first",
              selection: false,
              actionsColumnIndex: -1,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              grouping: false,
              columnsButton: false,
            }}
            icons={{
              Edit: () => <EditIcon sx={{ color: "#637381" }} />,
            }}
            editable={{
              onRowUpdate: (newRow, oldRow) =>
                new Promise((resolve, reject) => {
                  if (!newRow?.target) {
                    return reject();
                  }
                  handleSubmitRowData(newRow, "edit");
                  setTimeout(() => resolve(), 500);
                }),
            }}
            components={{
                Overlay: () => null,
                OverlayLoading: () => <BackdropMeepl open={true} dark={false}/>,
            }}
            title={titleContent}
          />
        </Box>
      </Box>
  );
};



export default ATSUsersTargetGrid;
